import forEach from 'lodash-es/forEach';

export const DIALOG_OPENED = 'CARD_DETAIL_DIALOG_OPENED';
export const DIALOG_CHANGED = 'CARD_DETAIL_DIALOG_CHANGED';
export const DIALOG_CLOSED = 'CARD_DETAIL_DIALOG_CLOSED';
export const DIALOG_DATA_LOADED = 'CARD_DETAIL_DIALOG_DATA_LOADED';

export const UPDATE_DESCRIPTION_DRAFT = 'CARD_DETAILS_UPDATE_DESCRIPTION_DRAFT';
export const CLEAR_DESCRIPTION_DRAFTS = 'CARD_DETAILS_CLEAR_DESCRIPTION_DRAFTS';
export const UPDATE_LOCAL_CARD_TITLE = 'UPDATE_LOCAL_CARD_TITLE';
export const UPDATE_ATTRS = 'CARD_DETAIL_UPDATE_CARD_ATTRS';
export const UPDATE_ASSIGNMENTS = 'CARD_DETAIL_UPDATE_ASSIGNMENTS';
export const UPDATE_TAGS = 'CARD_DETAIL_UPDATE_TAGS';
export const UPDATE_BOARD_ID = `CARD_DETAIL_DIALOG_UPDATE_BOARD_ID`;
export const UPDATE_DELETED = `CARD_DETAIL_DIALOG_UPDATE_DELETED`;

export const _dialogOpened = (cardId, boardId) => {
  return {
    type: DIALOG_OPENED,
    cardId,
    boardId
  }
}

export const _dialogChanged = (cardId, previousCardId) => {
  return {
    type: DIALOG_CHANGED,
    cardId,
    previousCardId
  }
}

export const _dialogClosed = (cardId) => {
  return {
    type: DIALOG_CLOSED,
    cardId
  }
}

export const _dialogDataLoaded  = (cardId, deleted) => {
  return {
    type: DIALOG_DATA_LOADED,
    cardId,
    deleted
  }
}

export const _updateBoardId = (boardId) => {
  return {
    type: UPDATE_BOARD_ID,
    boardId
  }
}

export const _updateDeleted = (cardId, deleted) => {
  return {
    type: UPDATE_DELETED,
    cardId,
    deleted
  }
}

/**
 * Saves the editor's HTML as the card's `descriptionHtml`, and nothing else.
 * @param { String } id - Card id
 * @param { String } descriptionHtml - The editor's HTML
 * @param { String } currentDescriptionHtml - The `descriptionHtml` editing started from, kept as the draft's original if the save fails
 */
export const setDescription = (id, descriptionHtml = '', currentDescriptionHtml) => {
  return {
    type: UPDATE_ATTRS,
    id,
    descriptionHtml,
    currentDescriptionHtml
  }
}

/**
 * Records what the user has typed into the description editor and not saved, so a refresh, a second
 * tab, the mobile dialog and the AI Helper all see the same text.
 *
 * `originalDescription` is the description the editor is working against, captured alongside. The
 * someone-else-changed-this check reads it back after a refresh; without it a reload would take the
 * remote value for the one the user started from and the warning would never appear.
 *
 * @param { String } cardId - Id of the card being described.
 * @param { String } description - The unsaved text. Leaving it out drops the draft.
 * @param { String } originalDescription - The saved description this edit is against.
 */
export const updateDescriptionDraft = (cardId, description, originalDescription) => {
  return {
    type: UPDATE_DESCRIPTION_DRAFT,
    cardId,
    description,
    originalDescription
  }
}

/**
 * Drops every unsaved description, on logout, so the next user of this browser never sees them.
 */
export const clearDescriptionDrafts = () => {
  return {
    type: CLEAR_DESCRIPTION_DRAFTS
  }
}

/**
 * Dispatch action to update local description in redux state
 */
 export const updateLocalCardTitle = (cardId, title = '') => (dispatch) => {
  dispatch({
    type: UPDATE_LOCAL_CARD_TITLE,
    cardId,
    title
  });
}


/**
 * Sends request to set new title of this card
 * @param { String } id - Id of card which title should be udpated
 * @param { String } title - New title of card
 */
export const setTitle = (id, title) => {
  return {
    type: UPDATE_ATTRS,
    id,
    title
  }
}

/**
 * Sends request to change status of this card
 * @param { String } id - Id of card which status should be udpated
 * @param { String } status - New status of card
 */
export const updateStatus = (id, status) => {
  return {
    type: UPDATE_ATTRS,
    id,
    status
  }
}

/**
 * Send request to change priority of this card
 * @param { String } id - Id of card which priority should be udpated
 * @param { String } priority - New priority of card
 */
export const updatePriority = (id, priority) => {
  return {
    type: UPDATE_ATTRS,
    id,
    priority
  }
}

/**
 * Sends request to change Assignments of this card
 * @param { String } id - Id of card which Assignments should be udpated
 * @param { Array } assignments - New Assignments of card
 */
export const updateAssignments = (id, assignments) => {
  return {
    type: UPDATE_ASSIGNMENTS,
    id,
    assignments
  }
}

/**
 * Send request to change tags of this card
 * @param { String } cardId - Id of card which tags should be udpated
 * @param { Array } tags - New tags of card
 */
export const updateTags = (cardId, tags) => {
  return {
    type: UPDATE_TAGS,
    cardId,
    tags
  }
}

/**
 * Sends request to change due date of this card
 * @param { String } id - Id of card which due date should be udpated
 * @param { Number } dueDate - New due date of card
 */
export const updateDueDate = (id, dueDate) => {
  return {
    type: UPDATE_ATTRS,
    id,
    dueDate
  }
}

/**
 * Stop listing on firebase updates when card detail page is closed
 */
export const disconnect = (cardId, boardId) => {
  forEach(tabWiseDataLoad, (value, key)=> {
    value.disconnect(cardId, boardId);
  });
}
